import { effect, inject, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { CampaignService } from "../services/campaign.service";
import { RaceService } from "../services/race.service";
import { SessionService } from "../services/session.service";

import { Campaign } from "../interfaces/campaign";
import { Race } from "../interfaces/race";

export class CampaignWithRace {
  route = inject(ActivatedRoute);
  session = inject(SessionService);
  campaignService = inject(CampaignService);
  raceService = inject(RaceService);

  campaign = signal<Campaign>(undefined);
  race = signal<Race>(undefined);

  setLocalRace (race: Race, message: string = ''): void {
    this.race.set(race);
    this.session.setRace(race);
    this.session.iAmNotBusy();

    if (message !== '') {
      this.session.setNotifyMessage(message);
    }
  };

  constructor () {
    // console.log('properties - route', this.route);
    let raceId = signal(this.route.snapshot.paramMap.get('raceId') as string);
    let sessionRace = this.session.getRace();
    let sessionCampaign = this.session.getCampaign();

    // console.log('properties - race from session', sessionRace);
    if (raceId() === sessionRace?._id) {
      this.race.set(sessionRace);
      if (sessionRace.campaignId === sessionCampaign?._id) {
        this.campaign.set(sessionCampaign);
        // console.log('properties - campaign from session', sessionCampaign);
      }
    }
    else {
      // console.log('properties - raceId:', raceId());
      this.raceService.getRaceForId$(raceId()).subscribe(
        race => {
          // console.log('properties - fetching race', race);
          this.setLocalRace(race);
        }
      );
    }

    effect(() => {
      if ((sessionCampaign == null && this.race() == null) || this.race().campaignId === sessionCampaign?._id) {
        return;
      }
      // if (this.race().campaignId === sessionCampaign._id) {
      //   // this.campaign.set(sessionCampaign);
      //   // console.log('properties - campaign - nevermind, already set');
      //   return;
      // }
      // console.log('properties - campaignId:', this.race().campaignId);
      this.campaignService.getCampaignWithId(this.race().campaignId).subscribe(
        campaign => {
          this.session.setCampaign(campaign);
          this.campaign.set(campaign);
          // console.log('properties - fetching campaign', campaign);
        }
      );
    });
  }
}
